import React from 'react';
import DiscoveryTooltip from '../DiscoveryTooltip';
import { useLocation, useHistory } from 'react-router-dom';
import { logout } from '../Auth';


const NavigationTab = ({ icon: Icon, tooltip, path, text, home, disabled, exactPath, level=0, testId }) => {
  const { pathname } = useLocation();
  const history = useHistory();

  const currentPath = exactPath ? pathname === path : pathname.includes(path);
  const selected = home ? pathname === '/' || currentPath : currentPath;
  const handleClick = disabled ? () => null : () => history.push(path);

  return (
    <DiscoveryTooltip
      placement='right'
      text={tooltip}
    >
      <div
        // className={`navigation-tab ${selected ? 'navigation-tab-selected' : ''}`}
        className={'navigation-tab ' +
          ( selected ? 'navigation-tab-selected ' : '' ) + (
            disabled ? 'disabled ' : ''
          )}
        onClick={handleClick}
        style={{ marginLeft: level * 20 }}
        data-testid={testId}
      >
        <div className='d-flex align-items-center'>
          <Icon className='mr-1' />
          { text }
        </div>
      </div>
    </DiscoveryTooltip>
  )
}

const LogoutTab = ({ icon: Icon, text, tooltip }) => {
  return (
    <DiscoveryTooltip
      placement='right'
      text={tooltip}
    >
      <div 
        className='navigation-tab'
        data-testid='nav-logout'
        onClick={async () => {
            await logout();
            // replace() rather than reload(): reload() re-renders the SAME url, so logging out
            // of /advanced-config left that page as the current history entry to walk back
            // into (C2D-1198). Landing on the root puts the login screen there instead.
            window.location.replace('/');
          }
        }
      >
        <div className='d-flex align-items-center'>
          <Icon className='mr-2' />
          { text }
        </div>
      </div>
    </DiscoveryTooltip>
  );
}

export { 
  NavigationTab,
  LogoutTab
}